import { render, staticRenderFns } from "./ArticleOverview.vue?vue&type=template&id=3b6a1886&scoped=true&"
import script from "./ArticleOverview.vue?vue&type=script&lang=js&"
export * from "./ArticleOverview.vue?vue&type=script&lang=js&"
import style0 from "./ArticleOverview.vue?vue&type=style&index=0&id=3b6a1886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a1886",
  null
  
)

export default component.exports